module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-07-aad01f7c16be09f6b068509cb0bb780c.png";